import React, { useState } from 'react';
import { ChevronDown } from 'lucide-react';

const FAQ = ({ items, title = 'Frequently Asked Questions', subtitle, id = 'faq' }) => {
  const [open, setOpen] = useState(0);

  return (
    <section id={id} className="bg-white py-20 lg:py-28">
      <div className="max-w-4xl mx-auto px-6 lg:px-12">
        <div className="text-center mb-12">
          <div className="flex items-center justify-center gap-3 mb-4">
            <div className="w-8 h-px bg-rose-400" />
            <span className="text-rose-400 text-xs tracking-[0.4em] uppercase font-light">
              Common Questions
            </span>
            <div className="w-8 h-px bg-rose-400" />
          </div>
          <h2
            className="text-stone-800 mb-3"
            style={{ fontFamily: "'Playfair Display', serif", fontSize: 'clamp(1.8rem, 3.5vw, 2.8rem)' }}
          >
            {title}
          </h2>
          {subtitle && (
            <p className="text-stone-500 font-light max-w-2xl mx-auto">{subtitle}</p>
          )}
        </div>

        <div className="space-y-3" data-testid="faq-list">
          {items.map((item, i) => {
            const isOpen = open === i;
            return (
              <div
                key={i}
                className={`border transition-all duration-300 ${
                  isOpen ? 'border-rose-300 bg-rose-50/40' : 'border-stone-200 hover:border-stone-300 bg-white'
                }`}
                data-testid={`faq-item-${i}`}
              >
                <button
                  type="button"
                  onClick={() => setOpen(isOpen ? -1 : i)}
                  aria-expanded={isOpen}
                  className="w-full flex items-center justify-between text-left px-6 py-5 gap-4"
                  data-testid={`faq-toggle-${i}`}
                >
                  <span className="text-stone-800 font-medium text-base lg:text-lg pr-2">
                    {item.q}
                  </span>
                  <ChevronDown
                    className={`w-5 h-5 text-rose-400 flex-shrink-0 transition-transform duration-300 ${
                      isOpen ? 'rotate-180' : ''
                    }`}
                  />
                </button>
                {isOpen && (
                  <div className="px-6 pb-6 -mt-1">
                    <p className="text-stone-600 leading-relaxed">{item.a}</p>
                  </div>
                )}
              </div>
            );
          })}
        </div>
      </div>
    </section>
  );
};

export default FAQ;
